export default "__VITE_ASSET__b5855f4d__"